var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadSimpleRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 19v7a2 2 0 01-2 2H6a2 2 0 01-2-2v-7a1 1 0 112 0v7h20v-7a1 1 0 012 0zm-12.707.707a1.001 1.001 0 001.415 0l5-5a1 1 0 00-1.415-1.415L17 16.587V5a1 1 0 00-2 0v11.586l-3.293-3.293a1 1 0 10-1.415 1.415l5 5z"
  })));
}
export default SvgDownloadSimpleRegular;